import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  session: { user: null, token: null },
  notifications: [],
};

export const AuthSlice = createSlice({
  name: "AuthSlice",
  initialState,
  reducers: {
    setSession: (state, { payload }) => {
      console.log(payload, "@auth payload");
      state.session = payload;
    },
    setNotifications: (state, { payload }) => {
      state.notifications = payload;
    },
    setNotificationRead: (state, { payload }) => {
      const index = state.notifications.findIndex(
        (notification) => notification._id === payload?._id
      );
      if (index !== -1) {
        state.notifications[index] = {
          ...state.notifications[index],
          ...payload,
        };
      }
    },
    userLoggedOut: () => initialState,
  },
});

export const { setSession, userLoggedOut, setNotifications } =
  AuthSlice.actions;
export default AuthSlice.reducer;
